import { render, staticRenderFns } from "./QueryDisplay.vue?vue&type=template&id=b2865d4a&scoped=true&lang=html&"
import script from "./QueryDisplay.vue?vue&type=script&lang=js&"
export * from "./QueryDisplay.vue?vue&type=script&lang=js&"
import style0 from "./QueryDisplay.vue?vue&type=style&index=0&id=b2865d4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2865d4a",
  null
  
)

export default component.exports